import { createSelector } from 'reselect';
import TransportExceptionsColumns from '../../containers/TransportExceptionsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.TRANSPORT_EXCEPTIONS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.TRANSPORT_EXCEPTIONS.isLoading;

export const getData =
  ReportDefinitions.TRANSPORT_EXCEPTIONS.getDataFunction();

export const getColumns =
  createSelector(getData, TransportExceptionsColumns);
